import { CountUp } from 'countup.js';

export const countUpNumbers = () => {
	const numbers = document.querySelectorAll('.js-count-up');

	numbers.forEach((numberEl) => {
		if (
			!isElementInViewport(numberEl) ||
			numberEl.classList.contains('animated')
		)
			return;

		const countValue = Number(numberEl.innerText);
		numberEl.innerText = '0';
		const options = {
			startVal: 0,
			decimalPlaces: countDecimals(countValue),
		};

		const conter = new CountUp(numberEl, countValue, options);

		if (!conter.error) {
			conter.start();
			numberEl.classList.add('animated');
		} else {
			console.error(conter.error);
		}
	});
};

const countDecimals = (number) => {
	if (Math.floor(number) !== number) {
		return number.toString().split('.')[1].length;
	}
	return 0;
};

const isElementInViewport = (el) => {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <=
			(window.innerWidth || document.documentElement.clientWidth)
	);
};
